import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addToCart } from '../store/slices/appSlice';
import { useTranslation } from 'react-i18next';

const AddToCartButton = ({ productId, className = "btn btn-main w-100 rounded-pill py-8 flex-center gap-8 text-xs fw-bold", onAdd }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [added, setAdded] = useState(false);

    const handleClick = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        dispatch(addToCart(productId));
        setAdded(true);
        if (onAdd) onAdd();

        setTimeout(() => {
            setAdded(false);
        }, 1500);
    };

    if (added) {
        return (
            <button 
                type="button" 
                className="btn btn-success w-100 rounded-pill py-8 flex-center gap-8 text-xs fw-bold transition-2 shadow-xs"
                disabled
            >
                <i className="ph ph-check-circle text-md"></i>
                ✓
            </button>
        );
    }

    return (
        <button 
            type="button" 
            className={`${className} transition-2`}
            onClick={handleClick}
        >
            <i className="ph ph-shopping-cart-simple text-md"></i>
            {t('productDetail.addToCart')}
        </button>
    );
};

export default AddToCartButton;
